// import React, { useState, useEffect } from 'react'
// import Typography from '@material-ui/core/Typography';
// const MetaDataViewer = (props) => {
//     const { config, blockState, block, getTableData } = props;
//     const [calculatedValues, setCalculatedValues] = useState({});
//     const performOperation = (operation, fieldName, tableData) => {
//         if (!tableData || tableData.length === 0) return 0;

//         switch (operation) {
//             case 'count':
//                 return tableData.length;

//             case 'sum':
//                 return tableData.reduce((sum, row) => {
//                     let raw = row[fieldName];
                
//                     // fallback: if not found and ".value" exists in row
//                     if (raw === undefined && row[`${fieldName}.value`] !== undefined) {
//                         raw = row[`${fieldName}.value`];
//                     }
                
//                     let value = 0;
                
//                     if (raw != null) {
//                         if (typeof raw === "object" && "value" in raw) {
//                             const inner = raw.value;
//                             if (typeof inner === "string") {
//                                 value = parseFloat(inner) || 0;
//                             } else if (typeof inner === "number") {
//                                 value = inner;
//                             }
//                         } else if (typeof raw === "string") {
//                             value = parseFloat(raw) || 0;
//                         } else if (typeof raw === "number") {
//                             value = raw;
//                         }
//                     }
                
//                     return sum + value;
//                 }, 0);
                

//             default:
//                 return 0;
//         }
//     };

//     const formatNumberWithCommas = (number) => {
//         return number.toLocaleString('en-GB');
//     };

//     // Function to get the display value for a field
//     const getFieldValue = (field) => {
//         // Check if field has operation configuration
//         if (field.operation) {
//             const value = calculatedValues[field.value] || 0;
            
//             // If isPoundSymbol is true, format with pound symbol and commas
//             if (field.isPoundSymbol) {
//                 return `£${formatNumberWithCommas(value)}`;
//             }
            
//             return value;
//         }
//         return '-';
//     };

//     // Calculate values when config changes
//     useEffect(() => {
//         if (config[0]?.dataElements && block?.dependsOn) {
//             // Get table data from the dependency block
//             const tableData = getTableData ? getTableData(block.dependsOn) : [];
//             console.log("tableData", tableData);

//             if (tableData.length > 0) {
//                 const newCalculatedValues = {};

//                 config[0].dataElements.forEach(field => {
//                     if (field.operation) {
//                         const value = performOperation(field?.operation, field?.fieldName || field?.value, tableData);
//                         newCalculatedValues[field.value] = value;
//                     }
//                 });

//                 setCalculatedValues(newCalculatedValues);
//             }
//         }
//     }, [config, block?.dependsOn, getTableData]);
//     return (
//         <div style={{ padding: '24px 24px 24px 24px' }}>
//             <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
//                 <Typography
//                     style={{
//                         fontSize: "14px",
//                         fontWeight: 400,
//                         lineHeight: "21px",
//                         color: "rgba(43, 44, 53, 1)",
//                     }}
//                 >
//                     {block.title}
//                 </Typography>
//                 <div style={{ display: "flex", flexDirection: "row", flexWrap: 'wrap', gap: '5px' }}>
//                     {config[0].dataElements.map((field, idx) => (
//                         <div
//                             key={idx}
//                             style={{
//                                 padding: "12px",
//                                 boxSizing: "border-box",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 gap: "6px",
//                                 minWidth: '250px',
//                                 border: "1px solid rgba(233, 235, 245, 1)",
//                             }}
//                         >
//                             <Typography
//                                 style={{
//                                     fontSize: "12px",
//                                     fontWeight: 500,
//                                     lineHeight: "17px",
//                                     color: "rgba(95, 96, 113, 1)",
//                                 }}
//                             >
//                                 {field.label}
//                             </Typography>
//                             <Typography
//                                 style={{
//                                     fontSize: "14px",
//                                     fontWeight: 400,
//                                     lineHeight: "21px",
//                                     color: "rgba(146, 147, 166, 1)",
//                                 }}
//                             >
//                                 {getFieldValue(field)}
//                             </Typography>
//                         </div>
//                     ))}
//                 </div>
//             </div>

//         </div>
//     )
// }

// export default MetaDataViewer


import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import useStyles from './style';

const MetaDataViewer = (props) => {
  const { config, blockState, block, getTableData } = props;
  const [calculatedValues, setCalculatedValues] = useState({});
  const classes = useStyles();

  const performOperation = (operation, fieldName, tableData) => {
    if (!tableData || tableData.length === 0) return 0;

    switch (operation) {
      case 'count':
        return tableData.length;

      case 'sum':
        return tableData.reduce((sum, row) => {
          let raw = row[fieldName];

          // fallback: if not found and ".value" exists in row
          if (raw === undefined && row[`${fieldName}.value`] !== undefined) {
            raw = row[`${fieldName}.value`];
          }

          let value = 0;

          if (raw != null) {
            if (typeof raw === "object" && "value" in raw) {
              const inner = raw.value;
              if (typeof inner === "string") {
                value = parseFloat(inner) || 0;
              } else if (typeof inner === "number") {
                value = inner;
              }
            } else if (typeof raw === "string") {
              value = parseFloat(raw) || 0;
            } else if (typeof raw === "number") {
              value = raw;
            }
          }

          return sum + value;
        }, 0);

      default:
        return 0;
    }
  };

  const formatNumberWithCommas = (number) => number.toLocaleString('en-GB');

  const getFieldValue = (field) => {
    if (field.operation) {
      const value = calculatedValues[field.value] || 0;
      if (field.isPoundSymbol) {
        return `£${formatNumberWithCommas(value)}`;
      }
      return value;
    }
    return '-';
  };

  useEffect(() => {
    if (config[0]?.dataElements && block?.dependsOn) {
      const tableData = getTableData ? getTableData(block.dependsOn) : [];
      if (tableData.length > 0) {
        const newCalculatedValues = {};
        config[0].dataElements.forEach(field => {
          if (field.operation) {
            const value = performOperation(
              field?.operation,
              field?.fieldName || field?.value,
              tableData
            );
            newCalculatedValues[field.value] = value;
          }
        });
        setCalculatedValues(newCalculatedValues);
      }
    }
  }, [config, block?.dependsOn, getTableData]);

  return (
    <div className={classes.rootPadding}>
      <div className={classes.group}>
        <Typography className={classes.title}>
          {block.title}
        </Typography>

        <div className={classes.itemsWrap}>
          {config[0].dataElements.map((field, idx) => (
            <div key={idx} className={classes.card}>
              <Typography className={classes.fieldLabel}>
                {field.label}
              </Typography>
              <Typography className={classes.fieldValue}>
                {getFieldValue(field)}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MetaDataViewer;
